<template>

  <panel-navigation>

    <div>

      <div class="flex flex-row items-center justify-between mb-3">
        <h1 class="text-lg font-semibold">New Search</h1>
        <div class="border-1 border-gray-500 text-gray-600 bg-white text-xs text-bold px-4 py-2 rounded cursor-pointer" @click="$router.push('/history')"><i class="fa fa-arrow-left mr-2"></i> Back to History</div>
      </div>

      <hr class="border-b border-gray-100 mb-4">

      <div class="text-gray-600 text-sm mb-4">Find local businesses by keyword and location, then message them in bulk.</div>

      <div class="dashboard-box mb-6">
        <v-card class="pa-2" tile>
          <div class="lf-search-form">
            <div class="flex flex-row flex-wrap">
              <div class="w-full lg:w-1/2">
                <v-text-field
                  label="Keyword"
                  prepend-inner-icon="mdi-magnify"
                  v-model="search_keyword"
                  outlined
                  dense
                  hide-details
                  @keyup.enter="addSearch()"
                ></v-text-field>

                <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-2 ml-3 mr-3" />
              </div>

              <div class="w-full lg:w-1/2 -ml-6">
                <div class="lf-search-location-box">
                  <v-combobox
                    label="Location"
                    prepend-inner-icon="mdi-map-marker-outline"
                    v-model="autocompleteLocationModel"
                    :items="locationFoundItems"
                    :search-input.sync="locationSearchText"
                    item-text="value"
                    item-value="id"
                    hide-no-data
                    return-object
                    outlined
                    dense
                    hide-details
                    @change="selectPlace()"
                    style="height: 40px; border: 0px;"
                  ></v-combobox>

                  <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-4 ml-3 -mr-3" />
                </div>
              </div>

              <div class="lf-search-form-search-type">
                <v-radio-group class="mt-2" row v-model="search_type">
                  <v-radio label="Local" :value="'local'" :ripple="false"></v-radio>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-radio label="In-depth" :value="'in_depth'" :ripple="false"></v-radio>
                      </span>
                    </template>
                    <span>In-depth search is currently working for USA cities only.</span>
                  </v-tooltip>
                </v-radio-group>
              </div>

              <div class="lf-search-form-submit-button" @click="addSearch()">
                <i v-if="savingSearch" class="fa fa-spin fa-spinner"></i>
                <i v-else class="mdi mdi-magnify"></i>
              </div>
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="add_search_error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
        <div v-html="add_search_error"></div>
      </div>

    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import { GetSuggestions } from '@/utils/PlaceUtils'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "New Search | " + this.$appName
    }
  },
  components: {
    PanelNavigation
  },
  data () {
    return {
      search_keyword: null,
      add_search_error: null,

      autocompleteLocationModel: null,
      locationSearchText: null,
      locationEntries: [],

      search_location: null,
      search_type: 'local',

      savingSearch: false
    }
  },
  computed: {
    locationFoundItems () {
      return this.locationEntries
    }
  },
  methods: {
    getAddressObject (address_components) {
      var ShouldBeComponent = {
        street_number: ["street_number"],
        zip: ["postal_code"],
        address: ["street_address", "route"],
        state: [
          "administrative_area_level_1",
          "administrative_area_level_2",
          "administrative_area_level_3",
          "administrative_area_level_4",
          "administrative_area_level_5"
        ],
        city: [
          "locality",
          "sublocality",
          "sublocality_level_1",
          "sublocality_level_2",
          "sublocality_level_3",
          "sublocality_level_4"
        ],
        country: ["country"]
      };

      var address = {
        street_number: "", zip: "", address: "", state: "", city: "", country: ""
      };
      address_components.forEach(component => {
        for (var shouldBe in ShouldBeComponent) {
          if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (shouldBe === "country") {
              address[shouldBe] = component.short_name;
            } else {
              address[shouldBe] = component.long_name;
            }
          }
        }
      });
      return address;
    },
    selectPlace () {
      let that = this

      if (!this.autocompleteLocationModel || !this.autocompleteLocationModel.id) return

      $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel.id + "&key=AIzaSyBqF2vFVUoyeU3la0XVOQSOdkhgAfQdBEs", function (response) {
        let address = that.getAddressObject(response.results[0].address_components);
        let search_location = {};
        search_location.street_number = address.street_number;
        search_location.address = address.address;
        search_location.city = address.city;
        search_location.state = address.state;
        search_location.zip = address.zip;
        search_location.country = address.country;
        search_location.lat = response.results[0].geometry.location.lat;
        search_location.lng = response.results[0].geometry.location.lng;
        search_location.place_id = response.results[0].place_id;

        that.search_location = search_location;
      });
    },
    async addSearch () {
      this.add_search_error = null

      if (!this.search_keyword) {
        this.add_search_error = "Please enter a keyword.";
        return;
      }
      if (!this.search_location || !this.search_location.lat || !this.search_location.lng) {
        this.add_search_error = "Please pick a location from the suggestions so we have its coordinates.";
        return;
      }

      this.savingSearch = true;

      try {
        await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
          search_keyword: this.search_keyword,
          search_location: this.search_location,
          search_type: this.search_type
        }, {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.auth.jwt }
        })

        this.$store.dispatch('searches/fetch', { page: 1, itemsPerPage: 10 })
        this.$router.push('/history')
      } catch (e) {
        this.add_search_error = (e.response && e.response.data && e.response.data.error)
          ? e.response.data.error
          : "Could not start the search. Please try again.";
        this.savingSearch = false
      }
    }
  },
  watch: {
    locationSearchText (newVal) {
      var that = this;
      if (!newVal || newVal.length <= 3) return
      GetSuggestions(newVal)
        .then(function (res) { that.locationEntries = res; })
        .catch(function () {})
    }
  }
}
</script>
